// src/ConsumerApp/Screens/ProductsList/components/BulkRfqCategoryBanner.js
import React from 'react';
import WhatsappLogo from '../../../../assets/icons/WhatsApp.svg';

const BUSINESS_WHATSAPP_NUMBER = '918639065454';

export default function BulkRfqCategoryBanner({ categoryName }) {
  const isCement = categoryName?.toLowerCase().includes('cement');

  const handleOpenWhatsAppRFQ = () => {
    const materialReq = isCement ? 'Cement (50 bags and above)' : categoryName || 'Materials';
    const message = encodeURIComponent(`Hi, I have a bulk requirement for ${materialReq}. Please provide a quote.`);
    window.open(`https://wa.me/${BUSINESS_WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  return (
    <div style={styles.container}>
      <div style={styles.leftGroup}>
        <div style={styles.iconCircle}>
          <img src={WhatsappLogo} alt="WhatsApp" style={{ width: 20, height: 20 }} />
        </div>
        <div>
          <h4 style={styles.title}>Got bulk requirement?</h4>
          <span style={styles.subtitle}>Share Requirement on WhatsApp.</span>
        </div>
      </div>
      <button style={styles.actionBtn} onClick={handleOpenWhatsAppRFQ}>
        Request for Quote
      </button>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: '#ECFDF5',
    borderRadius: 12,
    border: '1px solid #A7F3D0',
    padding: '14px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    boxSizing: 'border-box',
    margin: '12px 0',
  },
  leftGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
  },
  iconCircle: {
    width: 38,
    height: 38,
    borderRadius: 19,
    backgroundColor: '#25D366',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  title: {
    margin: 0,
    fontSize: 14,
    fontWeight: '700',
    color: '#2B2A29',
  },
  subtitle: {
    fontSize: 12,
    color: '#707B8C',
  },
  actionBtn: {
    backgroundColor: '#E9001E',
    color: '#FFFFFF',
    border: 'none',
    padding: '8px 16px',
    borderRadius: 8,
    fontSize: 12,
    fontWeight: '700',
    cursor: 'pointer',
    flexShrink: 0,
  },
};